import React from 'react';
import { tWithKeyAttr as t } from '../../i18nHelper';
import styles from './CalendarViewToggle.module.css';

export type CalendarViewMode = 'classic' | 'advanced';

interface ICalendarViewToggleProps {
  activeView: CalendarViewMode;
  onViewChange: (view: CalendarViewMode) => void;
}

const CalendarViewToggle: React.FC<ICalendarViewToggleProps> = ({
  activeView,
  onViewChange,
}) => {
  return (
    <div className={styles.toggleContainer}>
      <button
        className={`${styles.toggleButton} ${
          activeView === 'classic' ? styles.active : ''
        }`}
        onClick={() => onViewChange('classic')}
        aria-pressed={activeView === 'classic'}
      >
        <span className={styles.icon}>📅</span>
        <span className={styles.label}>{t('CALENDAR_VIEW_CLASSIC')}</span>
      </button>
      <button
        className={`${styles.toggleButton} ${
          activeView === 'advanced' ? styles.active : ''
        }`}
        onClick={() => onViewChange('advanced')}
        aria-pressed={activeView === 'advanced'}
      >
        <span className={styles.icon}>🗓️</span>
        <span className={styles.label}>{t('CALENDAR_VIEW_ADVANCED')}</span>
      </button>
    </div>
  );
};

export default CalendarViewToggle;
